if (!customElements.get('bdca-sticky-atc')) {
  customElements.define(
    'bdca-sticky-atc',
    class BdcaStickyAtc extends HTMLElement {
      connectedCallback() {
        this.observers = [];
        this.cleanups = [];

        this.sectionId = this.dataset.sectionId;
        this.form = document.getElementById(this.dataset.formId);
        this.mainButton = this.form ? this.form.querySelector('[name="add"]') : null;
        if (!this.mainButton) return;

        this.button = this.querySelector('.bdca-sticky-atc__button');
        this.label = this.button.querySelector(':scope > span');
        this.spinner = this.button.querySelector('.loading-overlay__spinner');
        this.price = this.querySelector('.bdca-sticky-atc__price');
        this.quantity = this.querySelector('.bdca-sticky-atc__quantity input');
        this.error = this.querySelector('.bdca-sticky-atc__error');

        this.initVisibility();
        this.initButton();
        this.initPrice();
        this.initQuantity();
        this.initError();
        this.initHeight();
      }

      disconnectedCallback() {
        this.observers.forEach((observer) => observer.disconnect());
        this.cleanups.forEach((cleanup) => cleanup());
        this.observers = [];
        this.cleanups = [];
        document.body.classList.remove('bdca-sticky-atc-active');
        document.body.style.removeProperty('--bdca-sticky-atc-height');
      }

      listen(target, type, handler) {
        target.addEventListener(type, handler);
        this.cleanups.push(() => target.removeEventListener(type, handler));
      }

      watch(target, callback, options) {
        const observer = new MutationObserver(callback);
        observer.observe(target, options);
        this.observers.push(observer);
      }

      initVisibility() {
        const observer = new IntersectionObserver(
          ([entry]) => {
            const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', visible);
            document.body.classList.toggle('bdca-sticky-atc-active', visible);
          },
          { rootMargin: '0px 0px 100000px 0px' }
        );
        observer.observe(this.mainButton);
        this.observers.push(observer);
      }

      initButton() {
        const sync = () => {
          const main = this.mainButton;
          const mainLabel = main.querySelector(':scope > span');
          const mainSpinner = main.querySelector('.loading-overlay__spinner');
          const ariaDisabled = main.getAttribute('aria-disabled');

          this.button.disabled = main.disabled;
          if (ariaDisabled === null) this.button.removeAttribute('aria-disabled');
          else this.button.setAttribute('aria-disabled', ariaDisabled);
          this.button.classList.toggle('loading', main.classList.contains('loading'));
          if (this.spinner && mainSpinner) {
            this.spinner.classList.toggle('hidden', mainSpinner.classList.contains('hidden'));
          }
          if (this.label && mainLabel) this.label.textContent = mainLabel.textContent.trim();
        };

        sync();
        this.watch(this.mainButton, sync, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          characterData: true,
          subtree: true,
        });

        this.listen(this.button, 'click', () => {
          const main = this.mainButton;
          if (main.disabled || main.getAttribute('aria-disabled') === 'true') return;
          main.click();
        });
      }

      initPrice() {
        if (!this.price) return;
        const mainPrice = document.getElementById(`price-${this.sectionId}`);

        if (mainPrice) {
          this.watch(
            mainPrice,
            () => {
              this.price.innerHTML = mainPrice.innerHTML;
              this.price.classList.toggle('visibility-hidden', mainPrice.classList.contains('visibility-hidden'));
            },
            { attributes: true, attributeFilter: ['class'], childList: true, characterData: true, subtree: true }
          );
          return;
        }

        const variantInput = this.form.querySelector('input[name="id"]');
        if (!variantInput) return;
        this.listen(variantInput, 'change', () => {
          fetch(`${this.dataset.productUrl}?variant=${variantInput.value}&section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const source = html.getElementById(this.price.id);
              if (source) this.price.innerHTML = source.innerHTML;
            })
            .catch((error) => console.error(error));
        });
      }

      initQuantity() {
        const mainQuantity = document.getElementById(`Quantity-${this.sectionId}`);
        if (!this.quantity || !mainQuantity) return;

        const fromMain = () => {
          if (this.quantity.value !== mainQuantity.value) this.quantity.value = mainQuantity.value;
        };
        const toMain = () => {
          if (mainQuantity.value === this.quantity.value) return;
          mainQuantity.value = this.quantity.value;
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        };

        fromMain();
        ['input', 'change'].forEach((type) => {
          this.listen(mainQuantity, type, fromMain);
          this.listen(this.quantity, type, toMain);
        });
      }

      initError() {
        const productForm = this.form.closest('product-form');
        const wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
        if (!this.error || !wrapper) return;

        const sync = () => {
          const message = wrapper.querySelector('.product-form__error-message');
          const text = message ? message.textContent.trim() : '';
          this.error.textContent = text;
          this.error.hidden = wrapper.hidden || !text;
        };

        sync();
        this.watch(wrapper, sync, {
          attributes: true,
          attributeFilter: ['hidden'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      initHeight() {
        const observer = new ResizeObserver(() => {
          document.body.style.setProperty('--bdca-sticky-atc-height', `${this.offsetHeight}px`);
        });
        observer.observe(this);
        this.observers.push(observer);
      }
    }
  );
}